import { RecommendationPayload } from "../../types/recommendations/recommendation-response";
import {
    IPersonalizedSuggestions,
    IPersonalizationPayload,
    ISuggestionResponse
} from "../../types/suggestion-response";

export function defaultSuggestionResponse(): ISuggestionResponse {
    return {
        articles: [],
        flexibleSets: [],
        contents: [],
        topSearchQueries: [],
        priceMandantSettingsArticles: {
            currencySymbolWeb: "",
            currencySymbolMobile: "",
            prependCurrencySymbolWeb: false,
            prependCurrencySymbolMobile: false
        },
        priceMandantSettingsFlexibleSet: {
            numberDecimalDigits: 0,
            numberGroupSizes: 0,
            numberDecimalSeparator: "",
            numberGroupSeparator: "",
            currencySymbol: "",
            prependCurrencySymbol: false
        }
    };
}

export function defaultMergedPersonalizedSuggestions(): IPersonalizedSuggestions {
    return {
        isSuggestionResponse: false,
        articles: [],
        flexibleSets: [],
        storedQueries: [],
        contents: [],
        topSearchQueries: [],
        featurePromotion: undefined,
        priceMandantSettingsArticles: {
            currencySymbolWeb: "",
            currencySymbolMobile: "",
            prependCurrencySymbolWeb: false,
            prependCurrencySymbolMobile: false
        },
        priceMandantSettingsFlexibleSet: {
            numberDecimalDigits: 0,
            numberGroupSizes: 0,
            numberDecimalSeparator: "",
            numberGroupSeparator: "",
            currencySymbol: "",
            prependCurrencySymbol: false
        }
    };
}

export function defaultPersonalizationPayload(): IPersonalizationPayload {
    return {
        isEnabled: false,
        recommendations: [],
        currencyInformation: { symbol: "", prependCurrencySymbol: false },
        topSearchQueries: [],
        storedQueries: []
    };
}

export function defaultRecommendationPayload(): RecommendationPayload {
    return {
        recommendations: [],
        currencyInformation: { symbol: "", prependCurrencySymbol: false }
    };
}
